export class Progressor {
    guid = "";
    max = 0;
    value = 0;
    text = "";
    finished = false;
}
